(function () {
  'use strict';

  function formatMoney(cents) {
    var format = (window.theme && window.theme.moneyFormat) || '${{amount}}';
    var amount = (cents / 100).toFixed(2);
    return format
      .replace(/\{\{\s*amount\s*\}\}/g, amount)
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/g, Math.round(cents / 100))
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/g, amount.replace('.', ','));
  }

  function getProductId() {
    var root = document.querySelector('[data-pairs-well-with]');
    if (root && root.dataset.productId) {
      return root.dataset.productId;
    }
    if (window.theme && window.theme.product && window.theme.product.id) {
      return window.theme.product.id;
    }
    return null;
  }

  function normalizeProduct(product) {
    var normalized = Object.assign({}, product);
    var variants = normalized.variants || [];

    if (normalized.options && normalized.options.length && typeof normalized.options[0] === 'string') {
      normalized.options = normalized.options.map(function (name, index) {
        var values = [];
        variants.forEach(function (variant) {
          var optionValue = getVariantOptions(variant)[index];
          if (optionValue && values.indexOf(optionValue) === -1) {
            values.push(optionValue);
          }
        });
        return { name: name, values: values };
      });
    }

    return normalized;
  }

  function loadProductDetails(product) {
    if (!product.handle) {
      return Promise.resolve(normalizeProduct(product));
    }

    return fetch('/products/' + product.handle + '.js')
      .then(function (response) {
        return response.json();
      })
      .then(function (fullProduct) {
        return normalizeProduct(fullProduct);
      })
      .catch(function () {
        return normalizeProduct(product);
      });
  }

  function getVariantOptions(variant) {
    if (variant.options && variant.options.length) {
      return variant.options;
    }
    return [variant.option1, variant.option2, variant.option3].filter(Boolean);
  }

  function findVariant(variants, selectedOptions) {
    return variants.find(function (variant) {
      var options = getVariantOptions(variant);
      return selectedOptions.every(function (value, index) {
        return options[index] === value;
      });
    });
  }

  function getAvailableValues(variants, optionIndex, selectedOptions) {
    var values = [];
    variants.forEach(function (variant) {
      if (!variant.available) return;
      var options = getVariantOptions(variant);
      var matches = true;
      for (var i = 0; i < optionIndex; i++) {
        if (options[i] !== selectedOptions[i]) {
          matches = false;
          break;
        }
      }
      if (matches && options[optionIndex] && values.indexOf(options[optionIndex]) === -1) {
        values.push(options[optionIndex]);
      }
    });
    return values;
  }

  function getSizedImageUrl(url, size) {
    if (!url) return url;
    var match = url.match(/\.(jpg|jpeg|gif|png|webp|bmp|tiff|tif)(\?v=\d+)?$/i);
    if (!match) return url;
    var parts = url.split(match[0]);
    return parts[0] + '_' + size + match[0];
  }

  function compileTemplate(template) {
    var encodeMap = { '<': '&lt;', '>': '&gt;', '&': '&amp;', '"': '&quot;', "'": '&#39;' };
    var regexp = /([\s'\\])(?!(?:[^{]|\{(?!%))*%\})|(?:\{%(=|#)([\s\S]+?)%\})|(\{%)|(%\})/g;

    function func(match, escapeChar, mode, code, blockStart, blockEnd) {
      if (escapeChar) {
        return { '\n': '\\n', '\r': '\\r', '\t': '\\t', ' ': ' ' }[escapeChar] || '\\' + escapeChar;
      }
      if (mode) {
        return mode === '='
          ? "'+_e(" + code + ")+'"
          : "'+((" + code + ")==null?'':(" + code + "))+'";
      }
      if (blockStart) return "';";
      if (blockEnd) return "_s+='";
      return match;
    }

    var encodeFn =
      'function(s){return (s==null?"":""+s).replace(/[<>&"\'\\x00]/g,function(c){return ' +
      JSON.stringify(encodeMap) +
      '[c]||"";});}';

    return new Function(
      'o',
      'tmpl',
      'var _e=' +
        encodeFn +
        ',_s=\'' +
        template.replace(regexp, func) +
        "';return _s;"
    );
  }

  function renderTemplate(template, data) {
    var render = compileTemplate(template);
    return render(data, { encode: renderTemplate.encode });
  }

  renderTemplate.encode = function (value) {
    return (value == null ? '' : '' + value)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');
  };

  function getJQuery() {
    return window.jQuery || window.$;
  }

  function formatCartForTemplate(cart) {
    var formatted = JSON.parse(JSON.stringify(cart));
    formatted.total_price = formatMoney(formatted.total_price);
    formatted.items.forEach(function (item) {
      item.line_price = formatMoney(item.line_price);
      item.image = getSizedImageUrl(item.image, '100x');
    });
    return formatted;
  }

  function updateMiniCartContent(cart) {
    var templateEl = document.querySelector('[data-mini-cart-template]');
    if (!templateEl) return;

    var formatted = formatCartForTemplate(cart);
    var html = renderTemplate(templateEl.innerHTML, formatted);

    document.querySelectorAll('[data-mini-cart-info]').forEach(function (el) {
      el.innerHTML = html;
    });

    document.querySelectorAll('[data-cart-total]').forEach(function (el) {
      el.textContent = formatted.item_count ? formatted.item_count : 0;
    });
  }

  function isDesktopCartViewport() {
    return window.matchMedia('(min-width: 801px)').matches;
  }

  function openMiniCart() {
    var jq = getJQuery();

    if (isDesktopCartViewport()) {
      var desktopToggle = document.querySelector('[data-toggle="mini-cart-desktop-info"]');
      if (desktopToggle) {
        desktopToggle.click();
        return;
      }

      if (jq) {
        jq('#mini-cart-desktop-info').foundation('open');
      }
      return;
    }

    var mobileToggle = document.querySelector('[data-toggle="mini-cart-info"]');
    if (mobileToggle) {
      mobileToggle.click();
      return;
    }

    if (jq) {
      jq('#mini-cart-info').foundation('open');
    }
  }

  function addToCartViaTheme(variantId, quantity) {
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
      },
      credentials: 'same-origin',
      body: JSON.stringify({
        id: variantId,
        quantity: quantity
      })
    })
      .then(function (response) {
        return response.json().then(function (data) {
          if (!response.ok) {
            throw new Error(data.description || data.message || 'Unable to add item to cart');
          }
          return data;
        });
      })
      .then(function (item) {
        if (item && item.message) {
          throw new Error(item.message);
        }

        var jq = getJQuery();
        if (jq) {
          jq('body').trigger('cart.added', item);
        }

        return fetch('/cart.js', {
          credentials: 'same-origin',
          headers: { Accept: 'application/json' }
        })
          .then(function (response) {
            return response.json();
          })
          .then(function (cart) {
            updateMiniCartContent(cart);

            if (jq) {
              jq('body').trigger('cart.get', cart);
              jq('body').trigger('cart.added.get.cart', item);
            }

            openMiniCart();
            return item;
          });
      });
  }

  function buildOptionSelects(itemEl, product) {
    var optionsWrap = itemEl.querySelector('[data-pww-options]');
    if (!optionsWrap || !product.options || !product.options.length) return;

    var hasOnlyDefault =
      product.options.length === 1 && product.options[0].name === 'Title' && product.options[0].values.length === 1;

    if (hasOnlyDefault) return;

    optionsWrap.innerHTML = '';

    product.options.forEach(function (option, optionIndex) {
      if (option.name === 'Title' && option.values.length === 1) return;

      var selectedOptions = getSelectedOptions(itemEl, product);
      var availableValues = getAvailableValues(product.variants, optionIndex, selectedOptions);

      if (!availableValues.length) {
        availableValues = option.values.slice();
      }

      var field = document.createElement('div');
      field.className = 'pairs-well-with__option';

      var label = document.createElement('label');
      label.className = 'pairs-well-with__option-label';
      label.textContent = option.name;
      label.setAttribute('for', 'pww-' + product.id + '-option-' + optionIndex);

      var select = document.createElement('select');
      select.className = 'pairs-well-with__select';
      select.id = 'pww-' + product.id + '-option-' + optionIndex;
      select.dataset.pwwOption = optionIndex;

      availableValues.forEach(function (value) {
        var opt = document.createElement('option');
        opt.value = value;
        opt.textContent = value;
        if (value === selectedOptions[optionIndex]) {
          opt.selected = true;
        }
        select.appendChild(opt);
      });

      select.addEventListener('change', function () {
        rebuildFollowingOptions(itemEl, product, optionIndex);
        updateItemState(itemEl, product);
      });

      field.appendChild(label);

      var selectWrap = document.createElement('div');
      selectWrap.className = 'pairs-well-with__select-wrap';
      selectWrap.appendChild(select);
      field.appendChild(selectWrap);
      optionsWrap.appendChild(field);
    });
  }

  function getSelectedOptions(itemEl, product) {
    var selects = itemEl.querySelectorAll('[data-pww-option]');
    var selected = [];
    selects.forEach(function (select) {
      selected[parseInt(select.dataset.pwwOption, 10)] = select.value;
    });

    if (!selected.length && product.variants.length) {
      return getVariantOptions(product.variants[0]);
    }

    return selected;
  }

  function rebuildFollowingOptions(itemEl, product, changedIndex) {
    var selects = itemEl.querySelectorAll('[data-pww-option]');
    var selectedOptions = getSelectedOptions(itemEl, product);

    selects.forEach(function (select) {
      var optionIndex = parseInt(select.dataset.pwwOption, 10);
      if (optionIndex <= changedIndex) return;

      var availableValues = getAvailableValues(product.variants, optionIndex, selectedOptions);
      var currentValue = select.value;

      select.innerHTML = '';
      availableValues.forEach(function (value) {
        var opt = document.createElement('option');
        opt.value = value;
        opt.textContent = value;
        select.appendChild(opt);
      });

      if (availableValues.indexOf(currentValue) !== -1) {
        select.value = currentValue;
      } else if (availableValues.length) {
        select.value = availableValues[0];
      }

      selectedOptions[optionIndex] = select.value;
    });
  }

  function updateItemState(itemEl, product) {
    var selectedOptions = getSelectedOptions(itemEl, product);
    var variant = findVariant(product.variants, selectedOptions) || product.variants[0];
    var priceEl = itemEl.querySelector('[data-pww-price]');
    var imageEl = itemEl.querySelector('[data-pww-image]');
    var button = itemEl.querySelector('[data-pww-add]');

    if (priceEl && variant) {
      priceEl.textContent = formatMoney(variant.price);
    }

    if (imageEl && variant) {
      var variantImage = variant.featured_image;
      if (variantImage && variantImage.src) {
        imageEl.src = variantImage.src;
      } else if (typeof variantImage === 'string') {
        imageEl.src = variantImage;
      } else if (product.featured_image) {
        imageEl.src = typeof product.featured_image === 'string' ? product.featured_image : product.featured_image.src;
      }
    }

    if (button && variant) {
      button.dataset.variantId = variant.id;
      button.disabled = !variant.available;
      button.textContent = variant.available ? 'Add to Cart' : 'Sold Out';
      button.classList.remove('is-added');
    }
  }

  function buildItem(product, currentProductId) {
    if (String(product.id) === String(currentProductId)) return '';

    var variants = product.variants || [];
    if (!variants.length) return '';

    var firstVariant = variants.find(function (v) {
      return v.available;
    }) || variants[0];

    if (!firstVariant) return '';

    var imageSrc = (firstVariant.featured_image && firstVariant.featured_image.src) ||
      firstVariant.featured_image ||
      (product.featured_image && product.featured_image.src) ||
      product.featured_image;

    var html =
      '<div class="pairs-well-with__item" data-pww-item data-product-id="' +
      product.id +
      '">' +
      '<a class="pairs-well-with__link" href="' +
      product.url +
      '">' +
      '<img class="pairs-well-with__image" data-pww-image src="' +
      imageSrc +
      '" alt="' +
      product.title.replace(/"/g, '&quot;') +
      '">' +
      '<p class="pairs-well-with__name">' +
      product.title +
      '</p>' +
      '<p class="pairs-well-with__price" data-pww-price>' +
      formatMoney(firstVariant.price) +
      '</p>' +
      '</a>' +
      '<div class="pairs-well-with__options" data-pww-options></div>' +
      '<div class="pairs-well-with__actions">' +
      '<div class="pairs-well-with__qty" data-number-group data-min="1">' +
      '<button type="button" class="pairs-well-with__qty-btn" data-pww-qty-minus aria-label="Decrease quantity">−</button>' +
      '<input type="text" class="pairs-well-with__qty-input" data-pww-qty data-number value="1" inputmode="numeric" aria-label="Quantity">' +
      '<button type="button" class="pairs-well-with__qty-btn" data-pww-qty-plus aria-label="Increase quantity">+</button>' +
      '</div>' +
      '<button type="button" class="pairs-well-with__add" data-pww-add data-variant-id="' +
      firstVariant.id +
      '"' +
      (firstVariant.available ? '' : ' disabled') +
      '>' +
      (firstVariant.available ? 'Add to Cart' : 'Sold Out') +
      '</button>' +
      '</div>' +
      '</div>';

    return html;
  }

  function bindItemEvents(itemEl, product) {
    loadProductDetails(product).then(function (fullProduct) {
      buildOptionSelects(itemEl, fullProduct);
      updateItemState(itemEl, fullProduct);
      bindItemControls(itemEl, fullProduct);
    });
  }

  function bindItemControls(itemEl, product) {
    var qtyInput = itemEl.querySelector('[data-pww-qty]');
    var minusBtn = itemEl.querySelector('[data-pww-qty-minus]');
    var plusBtn = itemEl.querySelector('[data-pww-qty-plus]');
    var addBtn = itemEl.querySelector('[data-pww-add]');

    if (minusBtn && qtyInput) {
      minusBtn.addEventListener('click', function () {
        qtyInput.value = Math.max(1, parseInt(qtyInput.value, 10) - 1 || 1);
      });
    }

    if (plusBtn && qtyInput) {
      plusBtn.addEventListener('click', function () {
        qtyInput.value = Math.max(1, parseInt(qtyInput.value, 10) + 1 || 2);
      });
    }

    if (qtyInput) {
      qtyInput.addEventListener('keyup', function () {
        if (/\D/g.test(qtyInput.value)) {
          qtyInput.value = qtyInput.value.replace(/\D/g, '');
        }
      });
      qtyInput.addEventListener('blur', function () {
        qtyInput.value = Math.max(1, parseInt(qtyInput.value, 10) || 1);
      });
    }

    if (addBtn) {
      addBtn.addEventListener('click', function () {
        if (addBtn.disabled) return;

        var variantId = addBtn.dataset.variantId;
        var quantity = Math.max(1, parseInt(qtyInput.value, 10) || 1);
        var originalText = addBtn.textContent;

        addBtn.disabled = true;
        addBtn.textContent = 'Adding...';

        addToCartViaTheme(parseInt(variantId, 10), quantity)
          .then(function () {
            addBtn.textContent = 'Added!';
            addBtn.classList.add('is-added');
            setTimeout(function () {
              var selectedOptions = getSelectedOptions(itemEl, product);
              var variant = findVariant(product.variants, selectedOptions) || product.variants[0];
              addBtn.textContent = originalText;
              addBtn.classList.remove('is-added');
              addBtn.disabled = !variant.available;
            }, 2000);
          })
          .catch(function () {
            addBtn.textContent = 'Try again';
            addBtn.disabled = false;
          });
      });
    }
  }

  function renderProducts(products, currentProductId) {
    var container = document.querySelector('[data-pairs-well-with-container]');
    if (!container) return;

    var items = products.filter(function (product) {
      return String(product.id) !== String(currentProductId);
    });

    if (!items.length) {
      hideWidget();
      return;
    }

    var renderedProducts = [];
    var markup = items
      .map(function (product) {
        var html = buildItem(product, currentProductId);
        if (html) renderedProducts.push(product);
        return html;
      })
      .filter(Boolean)
      .join('');

    if (!markup) {
      hideWidget();
      return;
    }

    container.innerHTML = markup;

    container.querySelectorAll('[data-pww-item]').forEach(function (itemEl, index) {
      bindItemEvents(itemEl, renderedProducts[index]);
    });
  }

  function hideWidget() {
    var root = document.querySelector('[data-pairs-well-with]');
    if (root) root.style.display = 'none';
  }

  function showProducts(products, productId) {
    var usable = (products || []).filter(function (product) {
      return product && product.id && String(product.id) !== String(productId);
    });

    if (!usable.length) {
      hideWidget();
      return;
    }

    try {
      renderProducts(usable, productId);
    } catch (error) {
      hideWidget();
    }
  }

  function fetchComplementaryProducts(productId) {
    return fetch('/recommendations/products.json?product_id=' + productId + '&limit=3&intent=complementary')
      .then(function (response) {
        if (!response.ok) {
          return [];
        }
        return response.json();
      })
      .then(function (data) {
        return (data && data.products) ? data.products : [];
      })
      .catch(function () {
        return [];
      });
  }

  function loadPairs(productId) {
    fetchComplementaryProducts(productId)
      .then(function (products) {
        showProducts(products, productId);
      })
      .catch(function () {
        hideWidget();
      });
  }

  function init() {
    var productId = getProductId();

    if (productId) {
      loadPairs(productId);
      return;
    }

    var match = window.location.pathname.match(/\/products\/([^/?]+)/);
    if (match) {
      fetch('/products/' + match[1] + '.js')
        .then(function (response) {
          return response.json();
        })
        .then(function (product) {
          loadPairs(product.id);
        });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
